module.exports = __webpack_public_path__ + "logo_alipay-c51ff856dbef0e9041c0d6101b54b1e7.png";


//////////////////
// WEBPACK FOOTER
// ./assets/logo_alipay.png
// module id = 1374
// module chunks = 1